type AnalyticsValue = string | number | boolean | null | undefined;
export type AnalyticsParams = Record<string, AnalyticsValue>;

const LOCAL_HOSTS = new Set(['localhost', '127.0.0.1', '::1']);

declare global {
  interface Window {
    gtag?: (...args: unknown[]) => void;
  }
}

function isTrackingEnabled(): boolean {
  return import.meta.env.PROD && !LOCAL_HOSTS.has(window.location.hostname);
}

function sanitizeParams(params: AnalyticsParams): Record<string, string | number | boolean> {
  const sanitized: Record<string, string | number | boolean> = {};
  Object.entries(params).forEach(([key, value]) => {
    if (value === null || value === undefined) {
      return;
    }
    if (typeof value === 'number' && !Number.isFinite(value)) {
      return;
    }
    sanitized[key] = value;
  });
  return sanitized;
}

export function trackEvent(eventName: string, params: AnalyticsParams = {}): void {
  if (!isTrackingEnabled() || typeof window.gtag !== 'function') {
    return;
  }
  window.gtag('event', eventName, sanitizeParams(params));
}

export function trackError(eventName: string, error: unknown, params: AnalyticsParams = {}): void {
  const message = error instanceof Error ? error.message : String(error ?? 'Unknown error');
  trackEvent(eventName, {
    ...params,
    error_message: message.slice(0, 160),
  });
}
